import { useState, useEffect } from "react";
import { faLayerGroup, faPalette, faWandSparkles, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Header } from "../../components/header/header";
import { ServiceHeader } from "../../components/services/service-header";
import { ServiceObject } from "../../components/services/graphics-service";
import { faImage } from "@fortawesome/free-regular-svg-icons";
import { GenLeft } from "../../components/utilities/service-framer";
import { graphicsProcesses, graphTools, grProcesses } from "../../_helpers/mock-data";
import { MotionFrame } from "../../components/utilities/framer";
import { GraphicStack } from "../../components/services/mobi-stack";
import { Footer } from "../../components/footer/footer";
import { GraphicsDialog } from "../../components/action-dialogs/graphics-actions";


export const GraphicsDesign = () => {

    const [showDialog, setShowDialog] = useState(false);

    const isOption = new URLSearchParams(window.location.search).get("options");

    useEffect(() => {
        isOption ?
        setShowDialog(true):
        setShowDialog(false);
    }, [isOption]);

    return (
        <div className="rand-page">
            <Header pageTitle={"Graphics Design"} />
            <GraphicsDialog 
                visible={showDialog} 
                toggleClose={() => setShowDialog(false)} 
            />
            <ServiceHeader
                gradText={"AI-Enhanced"}
                normText={"Creative Design"}
                descr={"Unleash unlimited creativity with AI-powered design tools that amplify your vision and bring extraordinary ideas to life."}
                descrImg={"/images/graphics-design.jpeg"}
                fBtnCap={"Create Magic"}
                sBtnCap={"View Portfolio"}
                fColor={"#0b8d0bff"}
                sColor={"#478f2bff"}
                onStart={() => setShowDialog(true)}
            />

            <MotionFrame>
                <div className="page-sub-cap">
                    <span className="norm-text">Create </span>
                    <span className="gradient-text">Design Services</span>
                </div>
                <div className="descr flx-rw-c">
                    From concept to creation, our AI-enhanced design process delivers exceptional visual experiences
                </div>
            </MotionFrame>

            <div className="services-box">
                <ServiceObject
                    topic={"Brand Identity"}
                    textDesc={"AI-assisted logo design and comprehensive brand identity systems"}
                    icon={faPalette}
                />
                <ServiceObject
                    topic={"Digital Art"}
                    textDesc={"AI-enhanced illustrations, digital paintings, and creative artwork"}
                    icon={faImage}
                />
                <ServiceObject
                    topic={"UI/UX Design"}
                    textDesc={"Intelligent interface design with AI-powered user experience optimization"}
                    icon={faLayerGroup}
                />

                <ServiceObject
                    topic={"Motion Graphics"}
                    textDesc={"Dynamic animations and AI-generated motion design elements"}
                    icon={faWandSparkles}
                />
            </div>
            <MotionFrame>
                <div className="page-sub-cap">
                    <span className="gradient-text">AI-Powered</span>
                    <span className="norm-text">Capabilities</span>
                </div>
                <div className="descr flx-rw-c">
                    Harness the power of artificial intelligence to push creative boundaries
                </div>
            </MotionFrame>
            <div className="services-box">
                {graphicsProcesses.map((process, indx) => (
                    <GenLeft key={indx}>
                        <div className="process-unit">
                            <div className="grp-proc-circle">
                                <FontAwesomeIcon icon={process.icon} />
                            </div>
                            <div className="process-caption">{process.caption}</div>
                            <div className="process-descr">{process.descr}</div>
                        </div>
                    </GenLeft>
                ))}
            </div>
            <MotionFrame>
                <div className="page-sub-cap">
                    <span className="gradient-text">Our</span>
                    <span className="norm-text">Creative Process</span>
                </div>
            </MotionFrame>
            <div className="services-box">
                {grProcesses.map((process, indx) => (
                    <GenLeft key={indx}>
                        <div className="process-unit">
                            <div className="gr-num-circle">0{indx + 1}</div>
                            <div className="process-caption">{process.caption}</div>
                            <div className="process-descr">{process.descr}</div>
                        </div>
                    </GenLeft>
                ))}
            </div>
            <MotionFrame>
                <div className="page-sub-cap">
                    <span className="gradient-text">Professional </span>
                    <span className="norm-text">Tools & AI</span>
                </div>
            </MotionFrame>
            <div className="services-box">
                {graphTools.map((obj, k) => (
                    <GraphicStack stack={obj} key={k} />
                ))}
            </div>
            <GenLeft>
                <div className="offer-bx glassy-effect">
                    <div className="q-cap">
                        <span className="norm-text of-cap">Ready to Create</span>
                        <span className="gradient-text of-cap"> Visual Magic</span>
                        <span className="norm-text of-cap">?</span>
                    </div>
                    <div className="descr">
                        Let's bring your creative vision to life with the power of AI-enhanced design
                    </div>
                    <div className="bttn">
                        <button className="of-btn-gen gr-bg">
                            <span className="of-btn-txt">Start Creating</span>
                            <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                    </div>

                </div>
            </GenLeft>
            <Footer />
        </div>
    )
}